import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromExam from './exam.reducer';

export const selectExamState = createFeatureSelector<fromExam.ExamState>(fromExam.examFeatureKey);

export const selectExam = createSelector(
  selectExamState,
  (state: fromExam.ExamState) => state.exams,
);
